export default "__VITE_ASSET__ab212168__"